import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

/** PageLinks — list of related pages. data: { items: [{ title, slug, description? }] } */
export default function PageLinks({ data = {} }) {
  const items = data.items || [];
  if (items.length === 0) return null;
  return (
    <section data-testid="site-block-page-links">
      <div className="max-w-6xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((it, i) => (
          <Link
            key={i}
            to={`/site/${it.slug}`}
            className="group rounded-2xl border orka-border-subtle p-5 orka-surface-base orka-transition-colors hover:orka-surface-raised flex items-start justify-between gap-4"
            data-testid={`site-block-page-link-${i}`}
          >
            <div>
              <div className="font-semibold orka-text-primary">{it.title}</div>
              {it.description && (
                <div className="mt-1 text-sm orka-text-secondary">{it.description}</div>
              )}
            </div>
            <ArrowUpRight className="w-4 h-4 orka-text-tertiary group-hover:orka-text-primary mt-0.5 shrink-0" />
          </Link>
        ))}
      </div>
    </section>
  );
}
